const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// RBC 20-ago-2026 -- SHIM CRITICO, NO BORRAR SIN LEER ESTO.
//
// cart.js declara: class CartItems extends window.StandardEvents.createViewEventElement(...)
// En este storefront window.StandardEvents NO existe (verificado en produccion el 20-ago-2026).
// Consecuencia en cadena:
//   1. cart.js revienta -> no se registran <cart-items>, <cart-note> ni <cart-remove-button>
//   2. cart-drawer.js revienta en "class CartDrawerItems extends CartItems" -> no se registra
//      <cart-drawer-items> (si registra <cart-drawer>, porque va antes)
//   3. CartDrawer.open() peta en querySelector('cart-drawer-items').dispatchViewEvent()
//   4. product-custom.js: la excepcion aborta el .then() y el contador del icono no se refresca
//   5. los botones +/- del drawer cambian el numero en pantalla pero NO actualizan el carrito real
//
// Este shim da una clase base valida cuando Shopify no expone la API. Debe implementar
// connectedCallback y disconnectedCallback porque las subclases de Dawn llaman a super.
// Se pierde solo el evento estandar de analitica "cart viewed"; toda la funcionalidad del
// carrito vuelve. Si algun dia Shopify expone StandardEvents de verdad, el shim no hace nada.
// constants.js se carga en el <head> con defer, o sea antes que cart.js: es el sitio correcto.
(function () {
  var se = window.StandardEvents;
  if (se && typeof se.createViewEventElement === 'function') return;
  window.StandardEvents = se || {};
  window.StandardEvents.createViewEventElement = function () {
    return class extends HTMLElement {
      connectedCallback() {}
      disconnectedCallback() {}
      dispatchViewEvent() {}
    };
  };
})();
